/* eslint-disable no-useless-escape */

export const isNullOrEmpty = (value: string | null | undefined) => !value || value.trim() === "";

export const emailRegex =
    /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

export function isMailValid(mail?: string): boolean {
    return (mail && emailRegex.test(mail)) || false;
}

export function isNumber(field: string): string {
    return field.replace(/[^0-9]/gi, "");
}

export function formatMaxLength(value: string, maxLength: number): string {
    if (maxLength) {
        return value.substring(0, maxLength);
    }
    return value;
}

export function formatPhoneNumber(phoneNumber: string, maxLength: number): string {
    if (!phoneNumber) {
        return "";
    }

    const value = isNumber(phoneNumber);
    const parts = [];

    for (let r = 0; r < value.length; r += 3) {
        parts.push(value.substring(r, r + 3));
    }

    if (parts.length) {
        return formatMaxLength(parts.join(" "), maxLength);
    }
    return formatMaxLength(value, maxLength);
}

export const isPasswordValid = (password: string | undefined, minLength: number = 6) =>
    ((password && password.length) || 0) >= minLength;

export const isTextTooShort = (text?: string, minLength: number = 5) =>
    text && text.trim().length >= minLength;

export const isTextTooLong = (text?: string, maxLength: number = 256) =>
    text && text.trim().length < maxLength;

export const isValidVisaCardNumber = (cardNumber: string): boolean => {
    cardNumber = cardNumber.replace(/\s/g, "");

    if (cardNumber.length <= 1 || cardNumber.match(/[^0-9 ]/)) {
        return false;
    }
    // Visa condition
    if (cardNumber[0] !== "4") {
        return false;
    }

    const checksum = Array.from(cardNumber)
        .reverse()
        .map((char, index) => {
            let digit = Number(char);
            digit = index % 2 === 1 ? digit * 2 : digit;
            digit = digit > 9 ? digit - 9 : digit;
            return digit;
        })
        .reduce((previous, current) => previous + current);

    return checksum % 10 === 0;
};

export const isFirstLastNameValid = (firstLastName: string) => {
    const regex = /^[A-Za-z0-9ĄąĆćĘęŁłŃńÓóŚśŹźŻż -]+$/i;
    return regex.test(firstLastName);
};
